"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    DpDropdownInput: {
        addTime: 'Add time',
        selectTimeAriaLabel: 'Select Time',
    },
};
